export const RATING_CATEGORY_FIELDS = [
  "taste",
  "ingredients",
  "variety",
  "portionSize",
] as const;
